module.exports = __webpack_public_path__ + "static/card-fda009c8849e6b0398c566a3cca837ef.png";